<template>
  <svg-vue
    v-tooltip="{
      content: 'We checked this action, but it hasn’t been completed yet. Please try again, and if you need any help, feel free to contact our support team.',
      placement: 'bottom',
      theme: 'dark-blue-tooltip',
    }"
    icon="icons/warning-orange"
    class="tw-w-6 tw-cursor-pointer"
  />
</template>

